import React from "react"
import Spinner from "react-bootstrap/Spinner"
import { FileImage } from "lucide-react"
import { downloadFile, getFilename, getFileSizeLabel, getFileTypeLabel, viewFile } from "./orderFileManagerUtils.js"

/**
 * @param {{
 *   uploading: { key: string, filename: string, sizeLabel: string }[],
 *   savedFiles: any[],
 *   isBusy: boolean,
 *   onDelete: (filename: string) => void,
 * }} props
 */
export default function OrderFileList({ uploading, savedFiles, isBusy, onDelete }) {
    return (
        <div className="order-file-manager__list">
            {uploading.map((row) => (
                <div key={row.key} className="order-file-manager__row">
                    <div className="order-file-manager__main">
                        <div className="order-file-manager__icon text-secondary">
                            <Spinner animation="border" size="sm" />
                        </div>
                        <div className="order-file-manager__meta">
                            <div className="order-file-manager__name" title={row.filename}>
                                <span className="fw-semibold text-primary">Uploading — </span>
                                {row.filename}
                            </div>
                            <div className="order-file-manager__size text-secondary">{row.sizeLabel}</div>
                        </div>
                    </div>
                </div>
            ))}
            {savedFiles.map((file, index) => {
                const filename = getFilename(file)
                const sizeLabel = getFileSizeLabel(file)
                const typeLabel = getFileTypeLabel(file)
                return (
                    <div key={`${filename}-${index}`} className="order-file-manager__row">
                        <div className="order-file-manager__main">
                            <div className="order-file-manager__icon text-secondary">
                                <FileImage size={28} aria-hidden />
                            </div>
                            <div className="order-file-manager__meta">
                                <div className="order-file-manager__name" title={filename}>{filename}</div>
                                <div className="order-file-manager__size text-secondary">
                                    {sizeLabel}
                                    {typeLabel ? <span className="fw-semibold">{sizeLabel ? " — " : ""}{typeLabel}</span> : null}
                                </div>
                            </div>
                        </div>
                        <div className="order-file-manager__actions">
                            <button type="button" className="order-file-manager__action" onClick={() => viewFile(file)} disabled={isBusy}>
                                View
                            </button>
                            <span className="order-file-manager__action-sep" aria-hidden>|</span>
                            <button type="button" className="order-file-manager__action" onClick={() => downloadFile(file)} disabled={isBusy}>
                                Download
                            </button>
                            <span className="order-file-manager__action-sep" aria-hidden>|</span>
                            <button
                                type="button"
                                className="order-file-manager__action order-file-manager__action--danger"
                                onClick={() => onDelete(filename)}
                                disabled={isBusy || !filename}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
